import { getStartupDataUrls } from "../config";

export const startupDataFetcher = async () => {
  return Promise.all(
    getStartupDataUrls().map((url) => {
      return fetch(url).then((response) => {
        return response.json();
      });
    }),
  );
};
